import apiService from "./globalService";

export const EmailService = ()=> {
    return{
        sendForm:(datas: any)=>{
           return apiService.post('https://api.emailjs.com/api/v1.0/email/send',datas)
        }
    }
}